<template>
  <div v-if="!loading">
    <ProductInformation v-for="product in products" :key="product.productid" :product-id="product.id" />
  </div>
  <div v-else class="text-center">
    <v-progress-circular indeterminate size="70" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import ProductInformation from './ProductInformation.vue';

export default {
  name: 'Marketplace',
  components: {
    ProductInformation
  },
  data () {
    return {
      loading: true
    };
  },
  computed: {
    ...mapState(['products'])
  },
  mounted: async function () {
    let rs = await this.getProducts();
    if (rs.code !== 0) {
      this.setError({ errorMessage: `Error - Unable to get products. Message: ${rs.message}` });
      this.$router.push({ path: '/error' });
    }
    this.loading = false;
  },
  methods: {
    ...mapActions([
      'getProducts'
    ]),
    ...mapMutations([
      'setError'
    ])
  }
};
</script>
